<template>
   <div
      id="jumbotron"
      class="jumbotron frontpage-jumbotron rounded-0 position-relative">
      <div
         id="material-wrap"
         v-touch:tap="void 0"
         class="container-fluid container-lg">
         <div
            id="frontFormular"
            class="row">
            <div
               id="main-product-grid"
               class="col-lg-7 position-relative mb-4">
               <div
                  v-if="currentStep !== 'view-stats'"
                  class="my-3 my-sm-5 text-center">
                  <h1>Se om du kan spare penge på dine forsikringer?</h1>
                  <h2 class="font-weight-normal d-none d-sm-block">Udfyld beregneren og se resultatet</h2>
               </div>
               <div
                  v-if="currentStep === 'select-products'"
                  ref="step">
                  <div class="d-flex flex-column align-items-center">
                     <div
                        class="icon-stack"
                        style="font-variant-numeric: tabular-nums; line-height: 1em">
                        <material-icon
                           class="text-secondary"
                           name="brightness_1" />
                        <span class="text-white fw-bold">1</span>
                     </div>
                     <h4 class="font-weight-normal text-center">Vælg de forsikringer du har behov for herunder</h4>
                  </div>
                  <products-grid
                     id="material-products"
                     class="product-selectors font-non-codensed"
                     @add="onProductAdded"
                     :limit="4"
                     :intro="true">
                     <div
                        class="skilt"
                        :style="{
                           width: small ? '110px' : '120px',
                           left: breakpoint === 'xs' ? '0' : '-10px',
                           top: breakpoint === 'xs' ? '-20px' : '-25px',
                        }" />
                  </products-grid>
                  <div class="d-flex justify-content-center invalid-feedback-wrap">
                     <CollapseTransition>
                        <div v-show="hasValidationError">
                           <div class="validation-message text-center text-danger mt-1">
                              Vi kan desværre kun vise forventede besparelser, hvis du tilvælger mindst én af flg.
                              <div class="d-flex flex-wrap align-items-center justify-content-center gap-1 my-2 fs-5">
                                 <div class="badge bg-secondary rounded-pill">Bil</div>
                                 <div class="badge bg-secondary rounded-pill">Indbo</div>
                                 <div class="badge bg-secondary rounded-pill">Hus</div>
                                 <div class="badge bg-secondary rounded-pill">Ulykke & Sundhed</div>
                                 <div class="badge bg-secondary rounded-pill">Fritidshus</div>
                              </div>
                           </div>
                        </div>
                     </CollapseTransition>
                  </div>
               </div>
               <div
                  v-else-if="currentStep === 'fill-form'"
                  ref="step">
                  <div class="d-flex flex-column align-items-center">
                     <div
                        class="icon-stack"
                        style="font-variant-numeric: tabular-nums; line-height: 1em">
                        <material-icon
                           class="text-secondary"
                           name="brightness_1" />
                        <span class="text-white fw-bold">2</span>
                     </div>
                     <h4 class="font-weight-normal text-center">Besvar nedenstående spørgsmål</h4>
                     <div
                        v-if="statsData"
                        class="container-fluid"
                        style="width: 400px; max-width: 100%">
                        <div class="mb-3">
                           <label for="housing_type">Boligtype</label>
                           <select
                              v-model="housingType"
                              id="housing_type"
                              class="form-select">
                              <option value="">Vælg</option>
                              <option
                                 v-for="option in Object.values(statsData.options.housing_types)"
                                 :value="option.value"
                                 v-text="option.value" />
                           </select>
                        </div>
                        <CollapseTransition>
                           <div v-if="groupByAge">
                              <label for="years_with_company">År hos nuværende selskab</label>
                              <select
                                 v-model="yearsWithCompany"
                                 id="years_with_company"
                                 class="form-select">
                                 <option value="">Vælg</option>
                                 <option
                                    v-for="option in Object.values(statsData.options.years_with_company)"
                                    :value="option"
                                    v-text="option" />
                              </select>
                           </div>
                        </CollapseTransition>
                     </div>
                  </div>
               </div>
               <div
                  v-else-if="currentStep === 'view-stats' && stats"
                  ref="step">
                  <div class="mt-3 mt-sm-5 mb-3 text-center">
                     <div><span class="rasmus-icon smiley"></span></div>
                     <h2>Tillykke - der er gode chancer for at du kan spare penge!</h2>
                  </div>
                  <div class="d-flex flex-column gap-4 gap-sm-2 mb-3 text-center">
                     <div class="stats-flex">
                        <div>{{ stats.switched }}</div>
                        <div>
                           har skiftet forsikringsselskab, fordi de har fået et bedre tilbud, efter de har brugt
                           Findforsikring.
                        </div>
                     </div>
                     <div class="stats-flex">
                        <div>{{ stats.conditions }}</div>
                        <div>
                           af dem der skiftede selskab, oplyser at de har fået endnu bedre dækninger efter de har brugt
                           Findforsikring.
                        </div>
                     </div>
                     <div class="stats-flex">
                        <div>{{ stats.savings }}</div>
                        <div>
                           er den gennemsnitslige besparelse for dem der sparer penge, der har brugt Findforsikring.
                        </div>
                     </div>
                  </div>
                  <div class="text-center">
                     Er du klar til at se om du kan spare penge?
                     <br />
                     Tryk herunder!
                  </div>
               </div>
               <div class="mt-3">
                  <button
                     type="button"
                     id="stats-next-button"
                     class="mx-auto d-block btn btn-lg btn-secondary btn-block px-5"
                     @click="nextClicked"
                     :title="currentStep === 'fill-form' && !stats ? 'Besvarelse mangler' : 'Gå til næste trin'"
                     :disabled="currentStep === 'fill-form' && !stats">
                     <span v-if="currentStep !== 'view-stats'">Næste</span>
                     <span v-else>Indhent tilbud</span>
                  </button>
                  <CollapseTransition v-if="currentStep === 'select-products'">
                     <div
                        v-if="hasValidationError"
                        class="text-center">
                        <a
                           title="Spring beregneren over og gå direkte til indhentning af tilbud"
                           href="#"
                           id="skip-form-button"
                           class="text-secondary fs-5 d-inline-block mt-4 mt-sm-3"
                           @click.prevent="goToForm">
                           Spring beregneren over og få 3 tilbud
                        </a>
                     </div>
                  </CollapseTransition>
                  <div
                     v-if="currentStep === 'fill-form'"
                     class="text-center">
                     <a
                        title="Spring beregneren over og gå direkte til indhentning af tilbud"
                        href="#"
                        id="skip-form-button"
                        class="text-secondary fs-5 d-inline-block mt-4 mt-sm-3"
                        @click.prevent="goToForm">
                        Spring beregneren over og få 3 tilbud
                     </a>
                  </div>
               </div>
               <div
                  v-if="stats && currentStep === 'view-stats'"
                  class="d-flex justify-content-center text-center mt-4">
                  <div style="width: 500px; max-width: 100%">
                     Ovenstående tal er beregnet ud fra de seneste {{ stats.count }} besvarelser Findforsikring har
                     fået, der matcher dine indtastninger. Brugerne der er en del af undersøgelsen kan godt have valgt
                     et andet mix af forsikringstyper.
                  </div>
               </div>

               <!--               <submit-products-button wrapper="#main-product-grid" />-->
            </div>
            <div class="col-lg-5 font-non-codensed px-lg-0">
               <div class="d-flex h-100 w-100 align-items-end justify-content-center">
                  <picture>
                     <source
                        srcset="/wp-content/themes/findforsikring_2015-sommer/2022/images/findforsikring_people.avif"
                        type="image/avif" />
                     <source
                        srcset="/wp-content/themes/findforsikring_2015-sommer/2022/images/findforsikring_people.webp"
                        type="image/webp" />
                     <source
                        srcset="/wp-content/themes/findforsikring_2015-sommer/2022/images/findforsikring_people.png"
                        type="image/jpeg" />
                     <img
                        class="img-fluid align-self-center"
                        src="/wp-content/themes/findforsikring_2015-sommer/2022/images/findforsikring_people.png"
                        alt="Brugere" />
                  </picture>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import SubmitProductsButton from '@components/SubmitProductsButton';
import ProductsGrid from '@components/ProductsGrid';
import WistiaPlayer from '@components/WistiaPlayer';
import { mapGetters } from 'vuex';
import MaterialIcon from '@components/MaterialIcon';
import CollapseTransition from '@ivanv/vue-collapse-transition/src/CollapseTransition.vue';

export default {
   name: 'FindforsikringStatsJumbo',
   components: {
      MaterialIcon,
      WistiaPlayer,
      ProductsGrid,
      SubmitProductsButton,
      CollapseTransition,
   },
   props: {
      custom: {
         type: Object,
         default: function () {
            return {};
         },
      },
   },
   data() {
      return {
         currentStep: 'select-products',
         statsData: null,
         housingType: '',
         yearsWithCompany: '',
         validationActive: false,
         requiredProducts: ['bil1', 'indbo', 'ulykke', 'hus', 'fritid'],
      };
   },
   computed: {
      ...mapGetters([
         'breakpoint',
         'header',
         'containerClass',
         'width',
         'small',
         'productCount',
         'formUrl',
         'selectedProducts',
      ]),
      containerClasses() {
         return `${this.containerClass} ${this.breakpoint}`;
      },
      headline() {
         return this.$store.getters.headline;
      },
      landingpage() {
         return this.$store.state.landingpage;
      },
      subtitle() {
         return this.landingpage && this.landingpage.subtitle ? this.landingpage.subtitle : null;
      },
      groupByAge() {
         if (this.statsData && this.housingType && this.statsData) {
            const option = Object.values(this.statsData.options.housing_types).find(
               (t) => t.value === this.housingType
            );
            return option.group_by_age;
         }
         return false;
      },
      stats() {
         if (this.statsData && this.housingType && (!this.groupByAge || this.yearsWithCompany)) {
            let statsKey = this.housingType;
            if (this.groupByAge) {
               statsKey += `_${this.yearsWithCompany}`;
            }
            return this.statsData.stats[statsKey];
         }
      },
      selectedProductIdentifiers() {
         return this.selectedProducts.map((product) => product.icon);
      },
      hasRequiredProduct() {
         for (const selectedProduct of this.selectedProductIdentifiers) {
            if (this.requiredProducts.indexOf(selectedProduct) !== -1) {
               return true;
            }
         }
         return false;
      },
      hasValidationError() {
         return this.validationActive && !this.hasRequiredProduct;
      },
      showSkipButton() {
         return this.currentStep === 'fill-form' || (this.currentStep === 'select-products' && this.hasValidationError);
      },
   },
   mounted() {
      fetch('/serverkode/feedback-stats.json').then(async (response) => {
         this.statsData = await response.json();
      });
   },
   methods: {
      nextClicked(e) {
         e.stopImmediatePropagation();
         switch (this.currentStep) {
            case 'select-products':
               if (this.currentStep === 'select-products') {
                  if (this.productCount === 0) {
                     window.tour.start('#main-product-grid');
                  } else if (!this.hasRequiredProduct) {
                     this.validationActive = true;
                  } else {
                     this.currentStep = 'fill-form';
                     this.scrollToTop();
                  }
               }
               break;
            case 'fill-form':
               if (this.stats) {
                  this.currentStep = 'view-stats';
                  this.scrollToTop();
               }
               break;
            case 'view-stats':
               this.goToForm();
               return;
         }
      },
      scrollToTop() {
         this.$nextTick(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
         });
      },
      goToForm() {
         document.location.href = this.formUrl;
      },
   },
};
</script>

<style lang="scss" scoped>
#jumbotron {
   background-color: var(--ff-stripe-bg);
}

#stats-table {
   font-size: 17px;
   max-width: 500px;
   margin: 0 auto;
   .td {
      padding: 0.5rem;
      width: 60%;
      vertical-align: middle;
      &:first-child {
         width: 40%;
         text-align: right;
         font-size: 2.5rem;
         font-weight: bold;
         line-height: 1em;
         white-space: nowrap;
      }
   }
}
.stats-flex {
   font-size: 15px;
   max-width: 400px;
   margin: 0 auto;
   :first-child {
      font-size: 2.5rem;
      font-weight: bold;
      line-height: 2.5rem;
      white-space: nowrap;
      text-align: center;
   }
}
.form-select {
   font-size: 1.25rem;
}
#stats-next-button {
   //display: block;
   height: 50px;
   //width: 140px;
   //margin: 20px auto 10px auto !important;
   &:disabled {
      pointer-events: unset;
      cursor: not-allowed;
   }
}

#frontFormular {
   padding-top: unset !important;
}

.extra-space {
   height: 2em;
}

.skilt {
   background-size: contain !important;
   height: 39px;
   top: -25px;
   color: var(--ff-blue);
   position: absolute;
   width: 124px;
   z-index: 500;
   background: url(/wp-content/themes/findforsikring_2015-sommer/images/graphics/forside-skilt.png) no-repeat left top
      transparent;
}

#material-wrap {
   font-size: 14px;

   .spacer {
      height: 75px;

      &.xs {
         height: 0;
      }
   }

   &.md {
      font-size: 14px;
   }

   &.sm {
      font-size: 12px;
   }

   &.xs {
      font-size: 10px;

      .extra-space {
         height: 0;
      }

      .spacer.top {
         height: 3em;
      }
   }

   .header-spacing {
      height: 0;
      transition: height 0.3s;

      &.active {
         height: 50px;
      }
   }

   h1 {
      font-weight: 800;
      font-stretch: 100%;
      margin-top: 0;
   }

   h2 {
      font-size: 170%;
   }

   .super-header {
      text-align: center;
      font-size: 120%;
      position: absolute;
      top: -30px;
      left: calc(50% - 3.9em);
   }

   #more-wrap {
      width: 160px;
      margin: 10px auto;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px 10px;
      border-radius: 3px;
      position: relative;

      .more-button {
         font-size: 18px;
      }
   }

   .cell {
      width: 170px;
      margin: 0 auto;
      height: 50px;
   }
}
</style>
